import React from "react";
import SummaryCards from "../../components/Cards/SummaryCards";
import Charts from "../../components/Charts/Charts";
import RecentActivity from "../../components/Cards/RecentActivity";
import { useUserProfile } from "../../hooks/useUserProfile";
import { useEnterpriseData } from "../../hooks/useEnterpriseData";
import { useDashboardData } from "../../hooks/useDashboardData";
import "../../styles/Dashboard.css";

const Dashboard = () => {
  const { profile, loadingProfile } = useUserProfile();

  // Espera carregar o profile para evitar chamadas desnecessárias
  const { enterprise, loadingEnterprise } = useEnterpriseData(
    loadingProfile || !profile?.enterpriseId ? null : profile.enterpriseId
  );

  const { summaryData, chartData, recentActivity, loading } = useDashboardData(
    enterprise?.id,
    profile?.id
  );

  if (loadingProfile || loadingEnterprise || loading || !profile || !enterprise) {
    return <p>Carregando...</p>;
  }

  return (
    <div className="dashboard-content">
      <h1>Dashboard RondaGO</h1>
      <SummaryCards data={summaryData} />
      <Charts data={chartData} />
      <RecentActivity data={recentActivity} />
    </div>
  );
};

export default Dashboard;
